import { Component } from '@inter-ikea-core/core';

// Add to entities which should be deleted directly instead of with the deleteProduct behaviour
export default class NonBehaviorDeleteComponent implements Component {
  static id = 2084;
  typeId = NonBehaviorDeleteComponent.id;
  doStoreInSnapshot: boolean = true;
  serializable: boolean = false;

  eq() {
    return false;
  }
}
